import * as React from 'react';

export default function Blogs() {
    return (
        <div>
            <h1>This page is not ready yet. :{'('}</h1>
            <h3>This section is in the works, I will be writing blogs while I search for jobs! Should I land a job, blogs are still planned for the future!</h3>
        </div>
    );
}